// extracted by mini-css-extract-plugin
export default {"oldPrice":"VwfwQtM8gSd2_f3bXnGn"};